// Header component for the dashboard

import {
  Box,
  HStack,
  Text,
  Image,
  Flex,
  Container,
} from '@chakra-ui/react';
import { useAuth } from '@/lib/sdk/auth/hooks';
import { ColorModeSwitcher } from '@/components/ColorModeSwitcher';
import LogoSvg from '../../../assets/logo.svg';
import { useNavigate } from 'react-router-dom';

/**
 * Header component with branding only
 * User menu is now in FloatingBottomNav
 */
export function Header() {
  const { currentOrg } = useAuth();
  const navigate = useNavigate();
  return (
    <Box
      as="nav"
      position="sticky"
      top={0}
      zIndex={10}
      bg={'bg-canvas'}
      backdropFilter="blur(10px)"
      borderBottom="1px"
      borderColor="border-default"
    >
      <Container maxW="7xl" py={4}>
        <Flex justify="space-between" align="center">
          <HStack spacing={2} cursor="pointer" onClick={() => navigate(`/dashboard/${currentOrg!.id}/reports`)}>
            <Image src={LogoSvg} alt="TaskEye Logo" boxSize="32px" />
            <Text fontSize="xl" fontWeight="bold" color="brand.500">
              TaskEye
            </Text>
            {currentOrg && (
            <>
              <Text color="gray.400">|</Text>
              <Text fontSize="md" color="gray.500">
                {currentOrg.name}
              </Text>
            </>
          )}
          </HStack>
          <HStack spacing={4}><ColorModeSwitcher /></HStack>
        </Flex>
      </Container>
    </Box>
  );
}
